import { type Writable, writable } from 'svelte/store'
import type { JwtPayload } from 'jsonwebtoken'
import { userIsLoggedIn } from '../stores'

export const jwt: Writable<JwtPayload> = writable({})

const url: string = '/api/jwt'

function parseJwt(token: string) {
	const base64Url = token.split('.')[1]
	const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
	const jsonPayload = decodeURIComponent(
		window
			.atob(base64)
			.split('')
			.map(function (c) {
				return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
			})
			.join('')
	)

	return JSON.parse(jsonPayload) as JwtPayload
}

export async function getJwt(): Promise<boolean> {
	const response = await fetch(url)
	const json = await response.json()
	if (json.success) {
		const data = parseJwt(json.token)
		jwt.update((_) => data)
		userIsLoggedIn.set(true)
		return true
	} else {
		userIsLoggedIn.set(false)
		return false
	}
}

/**
 * HINT: don't touch unless you know what you are doing
 *
 * getJwT() returns a Promise
 * we need it to run before anything else
 * howver, forking Safari doesn't support it yet (maybe EoY 2026, it's in Interop 2026)
 * hence, we can't top-level await it
 * so we use a dirty, non-blocking IIFE whcih can cause other unexpected troubles
 *
 * to live is to suffer
 */

;(async () => {
	await getJwt().catch((error) => {
		console.error(error)
	})
})().catch((error) => {
	console.error(error)
})
